import React from 'react'
import "../Home/Post.css"
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import MessageRoundedIcon from '@mui/icons-material/MessageRounded';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import SentimentSatisfiedRoundedIcon from '@mui/icons-material/SentimentSatisfiedRounded';

import {PiSmileySad} from "react-icons/pi"
import {IoVolumeMuteOutline} from "react-icons/io5"
import {MdBlockFlipped} from "react-icons/md"
import {AiOutlineDelete} from "react-icons/ai"
import {MdReportGmailerrorred} from "react-icons/md"

import {LiaFacebookF} from "react-icons/lia"
import {FiInstagram} from "react-icons/fi"
import {BiLogoLinkedin} from "react-icons/bi"
import {AiFillYoutube} from "react-icons/ai"
import {RxTwitterLogo} from "react-icons/rx"
import {FiGithub} from "react-icons/fi"

import img1 from "../../assets/Following/img-2.jpg"
import img2 from  "../../assets/Following/img-3.jpg"
import img3 from  "../../assets/Following/img-4.jpg"


import { useState } from 'react';
import Comments from '../Comments/Comments';
import moment from 'moment';
import axiosInstance from '../../axios'
import { API_BASE_URL, API_KEY } from '../../constants';
import { format } from 'date-fns';



const PostUser = ({posts,post,setPosts,profileImg,modelDetails,images}) => {
  const [comments,setComments] =useState(post.comments)



  const [like,setLike] =useState(post.likes.length)
  const [unlike,setUnlike] =useState(post.is_liked_by_me)

  const [filledLike,setFilledLike] =useState(post.is_liked_by_me?<FavoriteRoundedIcon />:<FavoriteBorderOutlinedIcon />)
  const [unFilledLike,setUnFilledLike] =useState(post.is_liked_by_me)
  const loggedInUserObj=JSON.parse(localStorage.getItem('userData'))
  const loggedInUserId=loggedInUserObj.user_profile.member_id
  const handlelikes=(post)=>{
  
    if(!unlike)
    {
        const like_post=async () =>{
          try {
        
              const response = await axiosInstance.post(
                `${API_BASE_URL}story=likes/`,{"story":post.id,"liker":loggedInUserId},
                {
                  headers: {
                    'X-Api-Key': API_KEY,
                  },
                }
              );
              if(response.data.data){
                post.is_liked_by_me=true;
                post.my_liked_id=response.data.data.id;
              }
            } catch (error) {
              console.error('Error while deleting:', error);
            }
          }
        like_post();
     }
     else{

            if(post.my_liked_id){
                  const delete_post=async () =>{
                    try {
                  
                        const response = await axiosInstance.delete(
                          `${API_BASE_URL}story=likes/`+post.my_liked_id+'/',
                          {
                            headers: {
                              'X-Api-Key': API_KEY,
                            },
                          }
                        );
                      } catch (error) {
                        console.error('Error while deleting:', error);
                      }
                    }
                  delete_post();
              }
              else{
                console.log("Not liked by me!")
              }
     }
    setLike(unlike ? like -1 :like +1)
    setUnlike(!unlike)

    setFilledLike(unFilledLike ?   <FavoriteBorderOutlinedIcon /> : <FavoriteRoundedIcon />)
    setUnFilledLike(!unFilledLike)
  }
  

  const [showDelete,setShowDelete] = useState(false)
  const [showComment,setShowComment] = useState(false)


const handleDelete=(id)=>{
  const delete_post_details=async () =>{
    try {
  
        const response = await axiosInstance.delete(
          `${API_BASE_URL}story-with-attachments/`+id,
          {
            headers: {
              'X-Api-Key': API_KEY,
            },
          }
        );
      } catch (error) {
        console.error('Error while deleting:', error);
      }
    }
  const deleteFilter =posts.filter(val=> val.id !== id);
    setPosts(deleteFilter);
    setShowDelete(false);
    delete_post_details();
  }
 
  const [commentInput,setCommentInput] =useState("")

  const handleCommentInput=(e)=>{
     e.preventDefault()
     const create_comment=async () =>{
      try {
    
          const response = await axiosInstance.post(
            `${API_BASE_URL}story-comments/`,
            {
              "comment_content":commentInput,
              "story":post.id,
              "commenter":loggedInUserId
           },
            {
              headers: {
                'X-Api-Key': API_KEY,
              },
            }
          );
          if (response && response.data){
                const responseData=response.data.data;
                const id=responseData.id;
                const profilePic =responseData.commenter_profile_pic;
                const username=responseData.commenter_name
                const comment =responseData.comment_content
                const time= responseData.create_at
            
                const commentObj ={
                  id:id,
                  commenter_profile_pic:profilePic,
                  commenter_name:username,
                  comment_content:comment,
                  create_at:time
                }
                const insert =[...comments,commentObj]
                setComments(insert)
                setCommentInput("")
        }
        } catch (error) {
          console.error('Error while deleting:', error);
        }
      }
    
      create_comment();
    }

  const [socialIcons,setSocialIcons] = useState(false)

  return (
    <div className='post'>
      <div className='post-header'>
        <div className='post-user' style={{cursor:"pointer"}}>
            <img src={profileImg} className='p-img' alt="" />
            <h2>{modelDetails.ModelName}</h2>
            <p className='datePara'>{format(new Date(post.create_at), 'dd-MM-yyyy HH:mm:ss')}</p>
        </div>
         
         <div className='delete'>
         {showDelete && (
         <div className="options">
         {/* <button><PiSmileySad />Not Interested in this post</button>
         <button><IoVolumeMuteOutline />Mute this user</button>
         <button><MdBlockFlipped />Block this user</button> */}
         <button onClick={()=>handleDelete(post.id)}><AiOutlineDelete />Delete</button>
         {/* <button><MdReportGmailerrorred />Report post</button> */}
         </div>
         )}
          <MoreVertRoundedIcon className='post-vertical-icon' onClick={()=>setShowDelete(!showDelete)}/>
         </div>
       </div>
       {
    
    }
        <p className='body'>{
        (post.content).length <=300 ?
        post.content : `${(post.content).slice(0,300)}...`
        }</p>
        {/* { <h1>{post.id}</h1> } */}
        {post.attachments.length>0 && (<img src={post.attachments[0].attachment} alt="" className="post-img" />)}
      
      <div className="post-foot">
       <div className="post-footer">
        <div className="like-icons">
          <p className='heart' 
            onClick={()=>handlelikes(post)}
            style={{marginTop:"5px"}}
          >
            <div className="like-comment-container">
              <div className="icon-wrapper">
                {filledLike}
                <span className="icon-count">{like}</span>
                </div>
            </div>

          </p>
          <div className="like-comment-container">
              <div className="icon-wrapper">
                <MessageRoundedIcon 
                  onClick= {()=>setShowComment(!showComment)}
                  className='msg'  
                />
                <span className="icon-count">{comments.length}</span>
              </div>
          </div>
          {/* <ShareOutlinedIcon 
            onClick={()=>setSocialIcons(!socialIcons)}
            className='share'  
          /> */}

        {socialIcons && (
          
          <div className="social-buttons">        
    
            <a href="http://www.facebook.com" target="blank" className="social-margin"> 
              <div className="social-icon facebook">
                <LiaFacebookF className='social-links'/>
              </div>
            </a>
            
            <a href="https://pinterest.com/" target="blank"  className="social-margin">
              <div className="social-icon instagram">
                <FiInstagram className='social-links'/>
              </div>
            </a>
            
            <a href="http://linkedin.com/" className="social-margin" target="blank">
              <div className="social-icon linkedin">
                <BiLogoLinkedin className='social-links'/>
              </div> 
            </a>
         
            <a href="https://github.com/"  target="blank"  className="social-margin">
              <div className="social-icon github">
                <FiGithub className='social-links'/>
              </div>
            </a>
            
            <a href="http://youtube.com/" target="blank"  className="social-margin">
              <div className="social-icon youtube">
              <AiFillYoutube className='social-links'/>
              </div> 
            </a>
      
            <a href="http://twitter.com/" target="blank" className="social-margin">
              <div className="social-icon twitter">
              <RxTwitterLogo />
              </div> 
            </a>
       </div>
      )}
    </div>
        
{/* 
        <div className="like-comment-details">
          <span className='post-like'>{like} people liked it,</span>
          <span className='post-comment'>{comments.length} comments</span>
        </div>
         */}
       {showComment && (<div className="commentSection">
        <form onSubmit={handleCommentInput}>
          <div className="cmtGroup">
              {/* <SentimentSatisfiedRoundedIcon className='emoji'
              /> */}
              
              <input 
              type="text" 
              id="commentInput"
              required
              placeholder='Add a comment...'
              onChange={(e)=>setCommentInput(e.target.value)}
              value={commentInput}
               />
              
              <button className='customButton' type='submit'><SendRoundedIcon className='send' /></button> 
          
          </div>
        </form>

        <div className="sticky">
          {comments.map((cmt)=>(
            <Comments 
            modelDetails={modelDetails}
            className="classComment"
            cmt={cmt}
            key={cmt.id}
            />
          ))}
          </div>
        </div>
        )}

      </div>     
    </div>
  </div>
  )
}

export default PostUser